import get from 'transmute/get';
import { TEXT } from '../constants/keyPaths';
const getText = get(TEXT);
export const getEmail = message => {
  return getText(message);
};